/* js/mouseover.js */

jQuery( document ).ready(function( $ ) {



    $('.js-mouseover-trigger').hover(


        function(){

            var elTop = $(this).offset().top - $(window).scrollTop();

            var elLeft = $(this).offset().left


            var rt = ($(window).width() - ($(this).offset().left + $(this).outerWidth()));


            console.log('top '+ elTop);

            console.log('left '+ elLeft);

            console.log('right '+ rt);




            if(elTop < 155){
                $(this).closest('.js-mouseover').addClass('mouseover-bottom');
            }
            else{
                $(this).closest('.js-mouseover').removeClass('mouseover-bottom');
            }




            $(this).parent().find('.js-mouseover-target').fadeIn('fast');
        },
        function(){
            $(this).parent().find('.js-mouseover-target').fadeOut('fast');
        }
    );



});